import React, { useState, useEffect } from 'react';
import { displayOutsideComponents, hideOutsideComponents } from '../../../utils/helpers';
import SelectVehicleStep from './SelectVehicleStep/SelectVehicleStep';
import AccessoriesStep from './AccessoriesStep/AccessoriesStep';
import { FormExtraParams, LanguageCode } from '../../../types';

interface VehicleAccessoriesProps {
  formExtraParams: FormExtraParams & {
    introductionText: string;
    initStepTopContents: string;
    language: LanguageCode;
  };
}

export interface AccessoryCategory {
  id: string;
  title: string;
}

export interface AccessoryItem {
  part_number: string;
  name: string;
  description: string;
  price: string;
  image: string;
  popular?: boolean;
  category?: {
    id: string;
  };
}

export interface TrimData {
  title: string;
}

export interface AccessoriesData {
  accessories: {
    accessories: Record<string, AccessoryItem>;
    categories: Record<string, AccessoryCategory>;
  };
  trim: TrimData;
}

const VehicleAccessories: React.FC<VehicleAccessoriesProps> = ({ formExtraParams }) => {
  const { introductionText, initStepTopContents, language } = formExtraParams;
  const [currentStep, setCurrentStep] = useState<number>(1);
  const [accessoriesData, setAccessoriesData] = useState<AccessoriesData | null>(null);

  useEffect(() => {
    if (currentStep === 1) {
      displayOutsideComponents(initStepTopContents);
    } else {
      hideOutsideComponents(initStepTopContents);
    }
  }, [currentStep, initStepTopContents]);

  return (
    <div className="mz-vehicle-accessories">
      <div className="mz-vehicle-accessories__inner mz-page-top" data-current-step={currentStep}>
        {
          currentStep === 1 && (
            <SelectVehicleStep
              introductionText={introductionText}
              language={language}
              setCurrentStep={setCurrentStep}
              setAccessoriesData={setAccessoriesData}
            />
          )
        }
        {
          currentStep === 2 && accessoriesData && (
            <AccessoriesStep
              accessoriesData={accessoriesData}
              setCurrentStep={setCurrentStep}
              language={language}
            />
          )
        }
      </div>
    </div>
  );
};

export default VehicleAccessories;
